import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

export const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: baseline;
    
    & > p {
        display: none;
    }
    
    @media (min-width: ${wideBreakpoints.mobile}) {
        & > p {
            display: flex;
        }
    }
`;
